const FAVORITES_KEY = "fancym:favorites";
const TIMER_KEY = "fancym:timer-started-at";
const LAST_DURATION_KEY = "fancym:last-session-duration";

function readJson<T>(key: string, fallback: T): T {
  try {
    const value = localStorage.getItem(key);
    return value ? (JSON.parse(value) as T) : fallback;
  } catch {
    return fallback;
  }
}

export function readFavorites(): Set<string> {
  const values = readJson<string[]>(FAVORITES_KEY, []);
  return new Set(values.filter((value) => typeof value === "string"));
}

export function writeFavorites(values: Set<string>): void {
  localStorage.setItem(FAVORITES_KEY, JSON.stringify([...values]));
}

export function readTimerStart(): number | null {
  const value = Number(localStorage.getItem(TIMER_KEY));
  return Number.isFinite(value) && value > 0 ? value : null;
}

export function writeTimerStart(value: number | null): void {
  if (value === null) localStorage.removeItem(TIMER_KEY);
  else localStorage.setItem(TIMER_KEY, String(value));
}

export function readLastDuration(): number | null {
  const value = Number(localStorage.getItem(LAST_DURATION_KEY));
  return Number.isFinite(value) && value >= 0 ? value : null;
}

export function writeLastDuration(value: number): void {
  localStorage.setItem(LAST_DURATION_KEY, String(value));
}
